module.exports = __webpack_public_path__ + "img/img3.2a1868a0.jpg";